import http from '@/assets/js/http'
import { filterLowCodeMenu } from '@/util/util'
/**
 * Created by Administrator on 2017/8/24.
 */
export default {
  state: {
    user: {},
    roleList: [],
    org: [],
    currentOrg: "",
    menuList: [], //当前角色的菜单
    BPMDictionary: [], // product-price 用于匹配 product nature2 的字典表
    lowcodeMenus:[],
    hasMenus: false,
  },
  getters: {
    getUser(state){
      return state.user;
    },
    getOrg(state){
      return state.org;
    },
    getCurrentOrg(state){
      return state.currentOrg;
    },
    getUsername(state){
      if(state.user.username){
        return state.user.username;
      }else{
        return state.user.ebpUserName;
      }

    },
    getNameEn(state){
      return state.user.name_en;
    },
    getNameCn(state){
      return state.user.name_cn;
    },
    getOrganization(state){
      return state.user.organization;
    },
    getCategory(state){
      return state.user.category;
    },
    getPosition(state){
      return state.user.position;
    },
    getChannel(state){
      return state.user.position;
    },
    getRole(state){
      return state.user.role;
    },
    getResource(state){
      return state.user.resource;
    },
    getCurrentResource(state){
      return state.user.currentResource;
    },
    getSuperRoles(state){
      return state.user.list
    },
    getRoleList(state){
      return state.roleList
    },
    getmenuList(state){
      return state.menuList
    },
    getBPMDictionary(state){
      return state.BPMDictionary
    },
    getLowcodeMenus(state){
      return state.lowcodeMenus
    },
    getHasMenus(state){
      return state.hasMenus
    },
  },
  mutations: {
    setUser(state, user){
      state.user = user;
    },
    setRoleList(state, data){
      state.roleList = data;
    },
    setOrg(state, org){
      state.org = org;
    },
    setcurrentOrg(state, orgCode, orgName){
      state.currentOrg = orgName;
      window.localStorage.setItem('currentOrg', orgCode);
    },
    setmenuList(state, menu){
      state.menuList = menu;
    },
    setBPMDictionary(state, data){
      state.BPMDictionary = data;
    },
    setLowcodeMenus(state,data){
      state.lowcodeMenus = data;
    },
    setHasMenus(state,data){
      state.hasMenus = data;
    },
  },
  actions: {
    setUser(context, user){
      context.commit('setUser', user);
    },
    setOrg(context, org){
      context.commit('setOrg', org);
    },
    setcurrentOrg(context, org){
      context.commit('setcurrentOrg', org);
    },
    setmenuList(context, menu){
      context.commit('setmenuList', menu);
    },
    generateLowcodeMenu(context,{menu,router}) {
      if (menu.length > 0) {
        context.commit('setHasMenus', true)
      }
      const lcPages = filterLowCodeMenu(menu);
      const lcRoutes = lcPages.map(m=> ({
        path:  m.url,
        name:  m.functionKey,
        // props: { targetPath:   m.url },
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
      }))
      const parentRoute = router.options.routes.find(r => r.name == 'full');
      if (parentRoute) {
        parentRoute.children = [...parentRoute.children,  ...lcRoutes];
        router.addRoutes([parentRoute]); // 重新添加父路由（包含新子路由）
      }

      context.commit('setLowcodeMenus',lcPages)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js